import { Button } from '@octopus-do/octopus-storybook'
import { CircleStop } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  onClick: () => void
}

// Отключение — полоской по низу окна, как «Stop publishing» в Publish.
// В поле проперти кнопке места нет: аккаунт без пропертей до поля не доходит,
// и отсоединиться было нечем.
export const DisconnectStrip: React.FC<Props> = ({ onClick }) => (
  <div className={css.strip}>
    <Button
      className={css.button}
      priority="ghost"
      size="small"
      label="Disconnect"
      left={CircleStop}
      onClick={onClick}
    />
  </div>
)
